<template>
  <div class="serve">
    <List :list="serveData" :titleHref="'/serve'" />
    <Pagination @pageNumber="pageBtn" :pageSize="pageSize" :count="count"></Pagination>
  </div>
</template>

<script>
import List from '@/components/list';
import { serveJson } from '@/json/list';
import Pagination from '../components/pagination';

export default {
  name:'brand',
  data() {
    return {
      serveData: serveJson,
      count: serveJson.length,
      pageSize: 12,
    }
  },
  methods:{
    pageBtn(i,maxLength){
      this.serveData = [];
      serveJson.map((item,index) => {
        if(index < maxLength && index >= i)
          this.serveData.push(item)
      })
    }
  },
  components:{
    List,
    Pagination
  },
}
</script>
<style lang="scss" scoped>
    @import '@/style/variables.scss';
  .serve{
    width:$navWidth;
    margin:20px auto 40px;
    border-radius: 5px;
  }
</style>